import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import SEO from "../components/SEO";
import { getOrderStatus } from "../lib/shopApi";
import { cart } from "../lib/cart";

export default function OrderComplete() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState({ phase: "checking" });

  useEffect(() => {
    if (!sessionId) return setState({ phase: "missing" });
    let tries = 0;
    let timer;
    const poll = async () => {
      try {
        const s = await getOrderStatus(sessionId);
        if (s.payment_status === "paid") {
          cart.clear();
          return setState({ phase: "paid", ...s });
        }
        if (s.payment_status === "expired") return setState({ phase: "expired" });
      } catch {
        /* keep polling */
      }
      tries += 1;
      if (tries < 12) timer = setTimeout(poll, 2000);
      else setState({ phase: "pending" });
    };
    poll();
    return () => clearTimeout(timer);
  }, [sessionId]);

  const copy = {
    checking: ["One moment…", "We're confirming your payment with the bank."],
    paid: ["Thank you, friend!", `Your order ${state.order_number || ""} is in. A receipt is on its way to your inbox, and we'll email tracking as soon as it ships.`],
    pending: ["Almost there", "Your payment is still being confirmed. You'll receive an email as soon as it's complete."],
    expired: ["Checkout expired", "No payment was taken. Your basket is still waiting in the Story Barn."],
    missing: ["Nothing to see here", "We couldn't find an order to show."],
  }[state.phase];

  return (
    <div className="parchment min-h-screen flex items-center justify-center px-6 py-24" data-testid="order-complete-page">
      <SEO title="Thank You — The Story Barn" description="Your Story Barn order." path="/story-barn/order-complete" />
      <div className="max-w-xl text-center">
        <div className="gold-rule mx-auto mb-8 w-32" />
        <h1 className="font-display text-4xl sm:text-5xl text-[#4B3A2F] mb-4" data-testid="order-complete-heading">{copy[0]}</h1>
        <p className="font-body text-lg text-[#2C2724]/85 leading-relaxed" data-testid="order-complete-message">{copy[1]}</p>
        <div className="gold-rule mx-auto mt-8 w-32" />
        <Link to="/story-barn" data-testid="order-complete-back-link"
          className="inline-block mt-10 rounded-full bg-[#4B3A2F] text-[#F9F6F0] px-8 py-3 uppercase tracking-[0.2em] text-xs hover:bg-[#3a2c23] transition-colors duration-300">
          Back to the Story Barn
        </Link>
      </div>
    </div>
  );
}
